"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchList = fetchList;
exports.getOperationList = getOperationList;
exports.getSysLog = getSysLog;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
function fetchList(query) {
  return (0, _requestPIM.default)({
    url: '/sysLog/list',
    method: 'get',
    params: query
  });
}
function getSysLog(id) {
  return (0, _requestPIM.default)({
    url: '/sysLog/info/' + id,
    method: 'get'
  });
}
function getOperationList() {
  return (0, _requestPIM.default)({
    url: '/sysLog/operations',
    method: 'get'
  });
}